/**
 * If you need to add a new tracker for Facelift NHS.
 */
(function index(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.Analytics = global.NewHomeSource.Analytics || {};

  if (!global.NewHomeSource.Analytics.impressionTracker ||
    !global.NewHomeSource.Analytics.identityTracker ||
    !global.NewHomeSource.Analytics.eventTracker ||
    !global.NewHomeSource.Modules.IdleQueue ||
    !global.NewHomeSource.Modules.IdleValue
  ) {
    return;
  }

  const nhsTrackingId = 'UA-40843711-4';

  function getGoogleAnalyticsClientId() {
    let googleAnalyticsId;

    if (global.ga && global.ga.getAll) {
      const trackers = global.ga.getAll().filter((element) => element.get('trackingId') === nhsTrackingId);
      googleAnalyticsId = trackers[0].get('clientId');
    }

    return googleAnalyticsId;
  }

  function getUserId() {
    return localStorage.getItem('UserId');
  }

  function getVisitedMpcIds() {
    return global.NewHomeSource.WebStorageHandler.getSessionStorageItem('visitedMpcIds');
  }

  function startTracking() {
    global.NewHomeSource.Analytics.eventTracker.init();
    global.NewHomeSource.Analytics.identityTracker.init();
    global.NewHomeSource.Analytics.impressionTracker.init();
    global.NewHomeSource.Analytics.onDemandTracker.init();
  }

  const eventsQueue = new global.NewHomeSource.Modules.IdleQueue();

  const handlers = [];
  const globalValues = {
    googleAnalyticsClientId: new global.NewHomeSource.Modules.IdleValue(getGoogleAnalyticsClientId),
    googleAnalyticsUserId: new global.NewHomeSource.Modules.IdleValue(getUserId),
    visitedMpcIds: getVisitedMpcIds,
  };

  handlers.push(global.NewHomeSource.Analytics.TdvTracker);
  handlers.push(global.NewHomeSource.Analytics.GoogleAnalyticsTracker);
  global.NewHomeSource.Analytics.eventTracker(eventsQueue, handlers);
  global.NewHomeSource.Analytics.identityTracker(eventsQueue, handlers);
  global.NewHomeSource.Analytics.impressionTracker(eventsQueue, handlers);
  global.NewHomeSource.Analytics.onDemandTracker(eventsQueue, handlers);
  global.NewHomeSource.Analytics.TdvTracker(globalValues);
  global.NewHomeSource.Analytics.GoogleAnalyticsTracker(globalValues);

  if (global.document.readyState === 'complete') {
    startTracking();
  } else {
    document.addEventListener('DOMContentLoaded', startTracking);
  }
}(window));
